import React from 'react';
import { connect } from 'react-redux';
import "./ImageTag.css";
import { injectIntl } from 'react-intl'
import { unsetIsImageTagActive } from '../../../actions/CommentAction'
import {Icon, Tooltip} from "antd";
import ImageIconDart from "../../../assets/icons/image_dart.svg";

class ImageTag extends React.Component {
    render() {
        const {
            versionNumber,
            unsetIsImageTagActive,
            imagePoint,
            intl
        } = this.props;
        return (
            <React.Fragment>
                <div className='image-tag-wrapper' >
                    <p>{intl.formatMessage({ id: "tagging_on_page" })} &nbsp; </p>
                    <div className='image-tag-text-indicator'>
                        <img src={ImageIconDart} alt="img" className='image-tag-icon' />
                        <p>{`${imagePoint} v.${versionNumber}`}</p>
                    </div>
                    <p>&nbsp;&nbsp;</p>
                    <Tooltip placement='top' title={intl.formatMessage({ id: "delete_pdf_tag" })}>
                        <p className='cursor-pointer' onClick={unsetIsImageTagActive}><Icon type="close-circle" /></p>
                    </Tooltip>

                </div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    isImageTagActive: state.comments.isImageTagActive,
    imagePoint: state.comments.imagePoint,
    versionNumber: state.comments.itemSelected.document.versionNumber

})

const mapDispatchToProps = {
    unsetIsImageTagActive
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ImageTag))
